<div class="field-wrapper" [formGroup]="formGroup">
    
    <div class="field-label">
        <label class="mb-0">
            <!-- Don't place line spaces between components in the line below bc it will create a char space in the field label -->
            {{field.label}}<span class="required-asterisk" *ngIf="field.required">*</span><a *ngIf="field.instructions" class="intructionlink" title="{{field.instructions}}">?</a>:
        </label>
    </div>

    <div class="field-input">
        <label class="control control--checkbox mb-0">
        <input type="checkbox" [formControlName]="fieldKey" class="field_submit multi-checkbox">
        <div class="control__indicator"></div>
        </label>
    </div>

</div>